import { ResearchAuthService } from "research.oidc.angular";
import { SettingsService } from "research.web.settings";
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from "@angular/router";
import { LoadingWrapperService } from "./shared/services/loading-wrapper.service";
import { CurrentUserService } from "./shared/services/current-user.service";
var AppComponent = /** @class */ (function () {
    function AppComponent(auth, settingsService, router, loadingService, currentUserService) {
        var _this = this;
        this.auth = auth;
        this.settingsService = settingsService;
        this.router = router;
        this.loadingService = loadingService;
        this.currentUserService = currentUserService;
        this.localStorageKey = "myUserInfo";
        this.showModal = false;
        this.versionNumber = "1.0.0";
        this.year = new Date().getFullYear();
        this.imageSrc = require("../../src/assets/corteva.svg");
        this.myCeLogo = require("../../src/assets/myCeLogo.svg");
        this.localStorageEventListener = function (e) {
            var key = e.key;
            // this key needs to match what is set in logout.html
            if (key === "wipeMe") {
                localStorage.removeItem("wipeMe");
                _this.logout();
            }
        };
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationStart) {
                _this.loadingService.setMessage("Loading...");
            }
            if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
                _this.loadingService.clearMessage();
            }
        });
        auth.onUnathenticatedResponse().subscribe(function (response) {
            _this.currentUserService.clear();
            _this.showModal = true;
        });
        window.addEventListener("storage", this.localStorageEventListener, false);
        this.settings = this.settingsService.get("_appSettings");
        this.environment = this.settings.environment;
        auth.initialize({
            loginRoute: "/login",
            afterLoginRoute: "/home",
            afterLogoutRoute: "/login",
            signInUrl: this.settings.signInUrl,
            signOutUrl: this.settings.signOutUrl,
            userInfoUrl: this.settings.refreshUrl,
            extendSessionDelay: 600,
            initializeClaims: function () {
                var data = localStorage.getItem(_this.localStorageKey);
                if (data) {
                    _this.setUserClaims(JSON.parse(data));
                }
                return data;
            },
            getClaims: function (response) {
                var shouldNavigate = _this.needToRedirect;
                _this.setUserClaims(response);
                localStorage.setItem(_this.localStorageKey, JSON.stringify(_this.userClaim));
                if (shouldNavigate) {
                    router.navigate([auth.afterLoginRoute]);
                }
                return _this.userClaim;
            }
        });
    }
    Object.defineProperty(AppComponent.prototype, "needToRedirect", {
        get: function () {
            return this.userClaim === null || this.userClaim === undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.login = function () {
        this.auth.login();
    };
    AppComponent.prototype.closeModal = function () {
        this.showModal = false;
        this.auth.refresh();
    };
    AppComponent.prototype.logout = function () {
        this.currentUserService.clear();
        localStorage.removeItem(this.localStorageKey);
        this.auth.logout();
    };
    AppComponent.prototype.onActivate = function (event) {
        window.scroll(0, 0);
    };
    AppComponent.prototype.setUserClaims = function (claims) {
        this.userClaim = claims;
        this.username = claims.username;
    };
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/app.component.ts.pre-build-optimizer.js